import { c as _c } from "react/compiler-runtime";
import { LazyImagePropertiesType } from "@website/ui/lazy-image/lazy-image.types";
import pick from "lodash-es/pick";
import toString from "lodash-es/toString";
import { FC, useEffect, useRef, useState } from "react";
export const LazyImage: FC<LazyImagePropertiesType> = properties => {
  const $ = _c(19);
  const {
    src,
    alt,
    className,
    fallback,
    fetchPriority,
    loading: t0,
    pictures
  } = properties;
  const loading = t0 === undefined ? "lazy" : t0;
  const imageReference = useRef(null);
  const [imageError, setImageError] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      imageReference.current?.addEventListener("error", setImageError.bind(null, true));
      return () => {
        imageReference.current?.removeEventListener("error", setImageError.bind(null, true));
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== properties) {
    t3 = pick(properties, "height", "width", "id", "title", "onClick", "onLoad");
    $[2] = properties;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== alt) {
    t4 = toString(alt);
    $[4] = alt;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `${className ?? ""} object-cover transition-all`;
  const t6 = loading === "eager" ? "auto" : "async";
  const t7 = fetchPriority ?? (loading === "eager" ? "high" : undefined);
  const t8 = fallback && (imageError || !src) ? fallback : src;
  let t9;
  if ($[6] !== loading || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <img {...t3} alt={t4} className={t5} decoding={t6} fetchPriority={t7} loading={loading} ref={imageReference} src={t8} />;
    $[6] = loading;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const Image = t9;
  if (pictures) {
    let t10;
    if ($[14] !== pictures) {
      t10 = pictures.map(_temp);
      $[14] = pictures;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== Image || $[17] !== t10) {
      t11 = <picture>{t10}{Image}</picture>;
      $[16] = Image;
      $[17] = t10;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    return t11;
  }
  return Image;
};
function _temp(picture) {
  return <source key={picture.media} media={`(${picture.media})`} srcSet={picture.srcSet} />;
}